import { User, UserAttributes } from "../types";

const getUserAttributes = (user: User): UserAttributes => {
  return {
    isUserSignedIn: user.isSignedIn,
  };
};

export default getUserAttributes;
